goog.provide('el8.uiwidget.CuratedList');

goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.confirm');


/**
 * This widget essentially renders a list of items, each of which
 * can be replaced in-line by a form for editing, and with a placeholder
 * at the end for adding new items (using the same in-line form).
 *
 * It is used in settings to manage the list of exam rooms that exist,
 * and TODO to manage CPT Codes, Print Headers, etc. It's good for the task
 * of managing the list of X that exist.
 */
el8.uiwidget.CuratedList = function(opts) {
    opts = opts || {};

    /* required settings for coherent function */
    this._container          = opts.container;
    this._listContainer      = $(opts.listSelector, this._container);
    this._listTemplateFn     = opts.listTemplateFn;
    this._formTemplateFn     = opts.formTemplateFn;
    this._saveFn             = opts.saveFn || this._defaultSaveFn;
    this._customValidationFn = opts.customValidationFn;
    this._entitySet          = opts.entitySet;
    this._fieldSpec          = opts.fieldSpec;
    this._itemDescriptionStr = opts.itemDescriptionStr;

    /* optional settings */
    this._sortable                  = (opts.sortable !== false); // default true
     // delete immediately or pop up alert?
    this._confirmDeletes            = (opts.confirmDeletes === true); // default false
     // if sorting requires re-rendering more than the order of the items, use this option
    this._reRenderOnSort            = (opts.reRenderOnSort === true); // default false
    this._highlightNewEntries       = (opts.highlightNewEntries === true); // default false
    this._liSelector                = '.curated-list-item' || opts.liSelector;
    this._sortHandleSelector        = '.sort-handle' || opts.sortHandleSelector;
    this._addBtnSelector            = '.add-trigger' || opts.addBtnSelector;
    this._editBtnSelector           = '.edit-trigger' || opts.editBtnSelector;
    this._removeBtnSelector         = '.remove-trigger' || opts.removeBtnSelector;
    this._mergeBtnSelector          = '.merge-trigger' || opts.mergeBtnSelector;
    this._formBtnContainerSelector  = '.form-buttons' || opts.formBtnContainerSelector;
    this._disableBtsOnFormShow      = (opts.disableBtsOnFormShow === true); // default false

    // support for adding non-standard functionality
    this._formPopulateFn            = opts.formPopulateFn || null;
    this._customDeleteFn            = opts.customDeleteFn || null;
    this._customMergeFn            = opts.customMergeFn || null;
    // preRender and postRender run at the beginning and end of _renderList
    // and allow rendering work beyond the template (e.g., tooltips)
    this._preRenderFn               = opts.preRenderFn || null;
    this._postRenderFn              = opts.postRenderFn || null;

    /* internal state */
    this._form = null;
    this._frozen = false; // represents whether or not it's ok to kill the form and run renderList
};

el8.uiwidget.CuratedList.prototype.init = function() {

    var that = this;
    this._listenerFn = function(eventName, arg) {
        if (that._highlightNewEntries && eventName === EVENTS.CREATED && arg && arg.getId()) {
            that._renderList(arg.getId());
        } else {
            that._renderList();
        }
    };
    this._entitySet.bind('all', this._listenerFn);

    if (this._sortable) {
        that._listContainer.sortable({
            items: that._liSelector,
            handle: that._sortHandleSelector,
            cursor: 'move',
            update: function(e, ui) {
                var listArray = _.map($(that._liSelector, that._listContainer), function(elem) {
                    return $(elem).data('id');
                });
                that._entitySet.reOrder(listArray, function() {
                    if (that._reRenderOnSort) { that._renderList(); }
                });
            }
        });
    }

    this._container
        .on('click', this._addBtnSelector, function() {
            that._showForm($('.new-form-stub', that._listContainer));

        }).on('click', this._editBtnSelector, function() {
            that._showForm($(this).closest(that._liSelector));

        }).on('click', this._mergeBtnSelector, function() {
            var id = $(this).closest(that._liSelector).data('id');
            var item = that._entitySet.getById(id);
            if (that._customMergeFn) {
                that._customMergeFn(item);
            }

        }).on('click', this._removeBtnSelector, function() {
            var id = $(this).closest(that._liSelector).data('id');
            var item = that._entitySet.getById(id);

            if (that._customDeleteFn) {
                that._customDeleteFn(item);
            } else if (that._confirmDeletes) {
                var confirmMsg = "Are you sure you want to permanently delete this " +
                    that._itemDescriptionStr + "?";
                el8.uiwidget.confirm(confirmMsg, function() { that._entitySet.deleteItem(item); });
            } else {
                that._entitySet.deleteItem(item);
            }
        });

    this._entitySet.softLoad(function() {
        that._listContainer.removeClass('el8Loading');
    }, true);

    return this;
};

el8.uiwidget.CuratedList.prototype.destroy = function(spec) {
    if (this._listenerFn) {
        // Note: I'm not sure this works very well. Unbinding specific functions seems to be buggy
        this._entitySet.unbind('all', this._listenerFn);
        this._listenerFn = null;
    }
    if (this._sortable) {
        this._listContainer.sortable('destroy');
    }
    this._container.empty();
    this._form = null;
};

el8.uiwidget.CuratedList.prototype.getForm = function() {
    // this will be null if a form is not currently open
    return this._form;
};

el8.uiwidget.CuratedList.prototype._renderList = function(highlightId) {
    // exists mostly to prevent realtime updates from wiping out work
    if (this._frozen) { return; }

    if (this._preRenderFn) { this._preRenderFn(this._listContainer); }

    this._listContainer.html(this._listTemplateFn());
    if (this._sortable) {
        this._listContainer.sortable('refresh');
    }
    $(this._addBtnSelector, this._container).show();

    if (el8Globals.FEATURES.BiDiLabs && this._disableBtsOnFormShow) {
        $(this._editBtnSelector, this._container).show();
        $(this._removeBtnSelector, this._container).show();
        $(this._mergeBtnSelector, this._container).show();
    }

    if (this._highlightNewEntries && highlightId) {
        var $listItem = $(this._liSelector+'[data-id="'+highlightId+'"]', this._listContainer);
        $listItem.addClass('el8Highlight');
        $.el8_setTimeout(function() {
            $listItem.removeClass('el8Highlight');
        }, 5*1000); // highlight for 5 seconds
    }

    if (this._postRenderFn) { this._postRenderFn(this._listContainer); }

    this._form = null;
};

el8.uiwidget.CuratedList.prototype._showForm = function($elem) {
    if (this._form) {
        el8.uiwidget.alert('Please finish editing the existing '+this._itemDescriptionStr+' or discard it first.');
        return;
    }
    this._frozen = true;
    var that = this;

    var elemId = $elem.data('id');
    // passing in elemId so that the form keeps a reference to the original item.
    // This way, custom validations on the form can know what the original item
    // was if there is a data-id in the form template.
    $elem.replaceWith(this._formTemplateFn(elemId));
    var $form = $('form', this._container);

    var formSpec = $.extend({
        container: $form,
        buttonElt: $(this._formBtnContainerSelector, $form),
        validationOpts: el8.util.validate.standardOpts
    }, { fields: this._fieldSpec });


    this._form = new el8.uiwidget.Form(formSpec);
    this._form.addSaveButton(function() {
        that._frozen = false;
        that._saveFn(that._form, $elem);
    }, true);
    this._form.addCancelButton(function() {
        that._frozen = false;
        that._renderList();
    });

    // Hide the re-order grippers, cause reordering while editing creates headaches
    if (this._sortable) {
        this._listContainer.find(this._sortHandleSelector).remove();
    }
    // Also hide the add form button until the form closes
    $(this._addBtnSelector, this._container).hide();

    // Also hide "edit", "remove", etc links (could become default) to avoid confusion
    if (el8Globals.FEATURES.BiDiLabs && this._disableBtsOnFormShow) {
        $(this._editBtnSelector, this._container).hide();
        $(this._removeBtnSelector, this._container).hide();
        $(this._mergeBtnSelector, this._container).hide();
    }

    this._form.render();

    if (elemId) {
        var item = this._entitySet.getById(elemId);
        if (this._formPopulateFn) {
            this._formPopulateFn(this._form, item);
        } else {
            this._form.populate(item.asSoyMap());
        }
        this._form.initFocus();
    }
};

/* The default save behavior will work if:
 * 1. each CuratedList <li> has a data-id attribute
 * 2. your form field names and model field names match up
 *      (so we can just put form.getMapped() into the model)
 * 3. the entity set has a saveFn on it
 * 4. the only error case to specially handle is a 409 (name conflict)
 */
el8.uiwidget.CuratedList.prototype._defaultSaveFn = function(form, $elem, opts) {
    var opts = opts || {};
    if (!form.isValid()) { return; }
    if (this._customValidationFn && !this._customValidationFn(form)) { return; }

    var that = this;
    var item;
    var elemId = $elem.data('id');
    if (elemId) {
        item = this._entitySet.getById(elemId);
    } else {
        item = this._entitySet.create({}, true); // noNotify: re-render when saved
    }
    item.populate(form.getMapped());

    this._entitySet.saveItem(item, false, {
        errorCb: function(item, xhrData) {
            if (xhrData.status === 409) {
                el8.uiwidget.alert('This '+that._itemDescriptionStr+' already exists. ' +
                    'Please edit the existing ' + that._itemDescriptionStr +
                    ' or pick a new name.');
            } else {
                el8.uiwidget.alert(el8.util.consts.DEFAULT_ERROR_MSG);
            }
        },
        successCb: opts.successCb ? opts.successCb : null
    });
};
